<template>
  <div class="footer">
    <div class="footer-privacy card">
      <div>
        <div class="footer-privacy-title">Política de privacidade do App Profissionais Android</div>
        <div class="footer-privacy-subtitle">
          Veja como tratamos dados pessoais, quem é a controladora e quais são os canais oficiais do EasySaúde.
        </div>
      </div>
      <router-link to="/politica-privacidade" class="footer-privacy-link">
        Abrir política
      </router-link>
    </div>

    <div class="footer-bottom">
      <div class="muted">© {{ new Date().getFullYear() }} EasySaúde. Contato para parcerias e demonstrações.</div>
      <div class="links">
        <a :href="appLoginUrl" target="_blank" rel="noopener noreferrer">Acesso do cliente</a>
        <span class="sep" aria-hidden="true">•</span>
        <router-link to="/politica-privacidade">Política de privacidade</router-link>
        <span class="sep" aria-hidden="true">•</span>
        <a href="https://sidsolucoes.com" target="_blank" rel="noopener noreferrer">SiD Soluções</a>
        <span class="sep" aria-hidden="true">•</span>
        <span>Sistemas Digitais</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterSection',
  props: {
    appLoginUrl: { type: String, required: true }
  }
}
</script>

<style scoped>
.footer {
  padding: 26px 0 10px;
}

.footer-privacy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 20px;
  margin-bottom: 14px;
  border: 1px solid rgba(77, 186, 135, 0.22);
  background: linear-gradient(180deg, rgba(77, 186, 135, 0.08), rgba(255, 255, 255, 1));
}

.footer-privacy-title {
  font-weight: 950;
  color: var(--easy-dark);
  font-size: 15px;
}

.footer-privacy-subtitle {
  margin-top: 4px;
  color: var(--easy-muted);
  font-size: 13px;
  line-height: 1.5;
}

.footer-privacy-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 14px;
  border-radius: 999px;
  background: var(--easy-green);
  color: #fff;
  text-decoration: none;
  font-weight: 900;
  white-space: nowrap;
}

.footer-privacy-link:hover {
  background: var(--easy-green-2);
}

.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 14px;
  color: var(--easy-muted);
  font-weight: 700;
  font-size: 13px;
}

.links a {
  color: var(--easy-muted);
  text-decoration: none;
  border-bottom: 1px dashed rgba(100, 116, 139, 0.35);
}

.links a:hover,
.links a.router-link-active {
  color: var(--easy-dark);
  border-bottom-color: rgba(77, 186, 135, 0.7);
}

.sep {
  margin: 0 8px;
}

@media (max-width: 860px) {
  .footer-privacy {
    flex-direction: column;
    align-items: flex-start;
  }
  .footer-top {
    flex-direction: column;
    align-items: flex-start;
  }
  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
